export default "__VITE_ASSET__BL9H_4JN__"